export default "icons-skype"